"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILDropdown = void 0;
var react_1 = __importStar(require("react"));
var Select_1 = __importDefault(require("@mui/material/Select"));
var dropdown_variant_enum_1 = require("../../shared/enums/dropdown-variant.enum");
var material_1 = require("@mui/material");
var ILDropdown = function (_a) {
    var _b, _c, _d, _e;
    var clearAll = _a.clearAll, selectAllValue = _a.selectAllValue, props = __rest(_a, ["clearAll", "selectAllValue"]);
    var _f = (0, react_1.useState)(props.defaultValue || (props.multiple ? [] : '')), selected = _f[0], setSelected = _f[1];
    var arrItemValues = [];
    (_b = props.items) === null || _b === void 0 ? void 0 : _b.map(function (_a) {
        var value = _a.value;
        if (value !== selectAllValue) {
            arrItemValues.push(value);
        }
        return value;
    });
    var selectionChangeHandler = function (event) {
        var value = event.target.value;
        var selectedValues = value;
        var isMultiple = props.multiple && Array.isArray(value);
        if (isMultiple && selectAllValue && value.indexOf(selectAllValue) !== -1) {
            var returnDefault = Array.isArray(props.defaultValue) ? __spreadArray([], props.defaultValue, true) : [];
            var values = Array.isArray(selected) && value.length === arrItemValues.length + 1
                ? returnDefault
                : arrItemValues;
            selectedValues = values;
        }
        if (isMultiple && clearAll && value.indexOf(clearAll) !== -1) {
            selectedValues = [];
        }
        setSelected(selectedValues);
        props.onChange && props.onChange(selectedValues);
    };
    var defaultProps = {
        'aria-label': (_c = props['aria-label']) !== null && _c !== void 0 ? _c : (props === null || props === void 0 ? void 0 : props.variant) + ' dropdown',
        'data-testid': (_d = props['data-testid']) !== null && _d !== void 0 ? _d : 'il-dropdown',
    };
    (0, react_1.useEffect)(function () {
        props.defaultValue && props.onChange && props.onChange(props.defaultValue);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (react_1.default.createElement(Select_1.default, __assign({ value: selected }, props, defaultProps, { native: false,
        // overrides
        defaultValue: props.defaultValue || [],
        label: props.label,
        labelId: props.labelId,
        multiple: props.multiple || false,
        onChange: selectionChangeHandler,
        renderValue: props.renderValue,
        variant: props.variant || dropdown_variant_enum_1.DropdownVariantEnum.OUTLINED,
        sx: props.sx }), (_e = props.items) === null || _e === void 0 ? void 0 : _e.map(function (_a, key) {
        var option = _a.option, value = _a.value, disabled = _a.disabled;
        return (react_1.default.createElement(material_1.MenuItem, { value: value, key: key, disabled: disabled }, option));
    })));
};
exports.ILDropdown = ILDropdown;
